export function initActionClicks(query = document.querySelectorAll(".js-actionClick")) {
    for (const target of query) {
        const action = target.dataset.action;
        if (action) {
            target.addEventListener("click", function () {
                window.location.href = action;
            });
        }
    }
}

export function initFormSubmitClicks(query = document.querySelectorAll(".js-formSubmitClick")) {
    for (const target of query) {
        target.addEventListener("click", function () {
            target.closest('form').submit();
        });
    }
}

export function initFormSubmitChanges(query = document.querySelectorAll(".js-formSubmitChange")) {
    for (const target of query) {
        target.addEventListener("change", function () {
            target.closest('form').submit();
        });
    }
}